<ax-check-box [label]="label" [value]="defaultValue" ></ax-check-box>